<script lang="ts">
  import { route } from '$lib/state/route.svelte';
  import ProductsPage from './ProductsPage.svelte';
  import DatasheetsPage from './DatasheetsPage.svelte';
  import MarketingPage from './MarketingPage.svelte';
  import PriceListsPage from './PriceListsPage.svelte';

  const screen = $derived(route.current.tab === 'catalogue' ? route.current.sub ?? 'products' : 'products');
</script>

<div class="pq-scroll flex-1 overflow-y-auto">
  {#if screen === 'datasheets'}<DatasheetsPage />
  {:else if screen === 'marketing'}<MarketingPage />
  {:else if screen === 'price-lists'}<PriceListsPage />
  {:else}<ProductsPage />{/if}
</div>
